// Main "controller" component

import "./App.css";
import Navbar from "./components/Navbar";
import RestaurantCard from "./components/RestaurantCard";
import { useState, useEffect } from "react";
import { Footer } from "./components/Footer";
import { Restaurant } from "./models/RestaurantInfo";
import { Header } from "./components/Header";
import { GuidePage } from "./components/GuidePage";
import { createContext } from "react";

// Context used for supporting dark / light mode
// Classnames are given based on the context and will
// determine the styling of the components
export const ThemeContext = createContext(null);

const App = () => {
    // State storing restaurant data
    const [restaurants, setRestaurants] = useState<Restaurant[]>([]);
    const [selectedRestaurantId, setSelectedRestaurantId] = useState<number>(-1);
    const [navbarIsActive, setNavbarIsActive] = useState(false);
    const [theme, setTheme] = useState<string>("dark");
    // State used to inform user that data is being fetched
    const [loadingData, setLoadingData] = useState<boolean>(true);

    // Add demo data
    useEffect(() => {
        let restaurants: Restaurant[] = [];

        let aurum: Restaurant = {
            restaurantID: 1,
            restaurantName: 'Aurum',
            openingHours: 'MON-THU 7.30-18, FRI 10.30-14, SUN 12-15',
            address: 'Henriksgatan 2',
            website: 'https://www.karkafeerna.fi/',
            queueLabel: 'medium',
            queueLength: 6,
        };

        let kåren: Restaurant = {
            restaurantID: 2,
            restaurantName: 'Kåren',
            openingHours: 'MON-FRI 11-14',
            address: 'Tavastgatan 22',
            website: 'https://www.karkafeerna.fi/',
            queueLabel: 'short',
            queueLength: 2,
        };

        let arken: Restaurant = {
            restaurantID: 3,
            restaurantName: 'Arken',
            openingHours: 'MON-THU 11-15, FRI 11-14.30',
            address: 'Tehtaankatu 2',
            website: 'https://www.karkafeerna.fi/',
            queueLabel: 'long',
            queueLength: 22,
        };

        let asa: Restaurant = {
            restaurantID: 4,
            restaurantName: 'Asa',
            openingHours: 'MON-THU 11-14',
            address: 'Vänrikinkatu 3',
            website: 'https://www.karkafeerna.fi/',
            queueLabel: 'short',
            queueLength: 3,
        };

        restaurants.push(aurum)
        restaurants.push(kåren)
        restaurants.push(arken)
        restaurants.push(asa)
        setRestaurants(restaurants)
        setLoadingData(false)
    }, [])

    /*
    // Fetch information about all restaurants every 3s
    useEffect(() => {
        const interval = setInterval(() => {

        fetch("https://qtms-web-api.azurewebsites.net/api/restaurant/get-all-info")
            .then((response) => response.json() as Promise<Object>)
            .then((data) => {

                let array: Restaurant[] = [];

                for (const [key, value] of Object.entries(data)) {
                    array.push(value);
                }

                setRestaurants(array);
                setLoadingData(false)
            });
        }, 3000);

        return () => clearInterval(interval);
    }, []);
    */

    // Used when a restaurant is selected from the navbar
    const selectRestaurant = (ID: number) => {
        setSelectedRestaurantId(ID);
        toggleNavbar();
    }

    const toggleNavbar = () => {
        setNavbarIsActive((prevState) => !prevState);
    }

    const toggleTheme = () => {
        setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
    }

      return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
        <div className="app">
            <div
                className={navbarIsActive ? "left navbar-container-active" : "left"}
                id={theme}
            >
            <Navbar
                selectedRestaurantID={selectedRestaurantId}
                clickHandler={selectRestaurant}
                restaurants={restaurants}
                navbarIsActive={navbarIsActive}
                toggleNavbar={toggleNavbar}
                loadingData={loadingData}
            />
            </div>
                <div className="right">
                    <Header
                        navbarIsActive={navbarIsActive}
                        toggleNavbar={toggleNavbar}
                    />

                    <div className="content" id={theme}>
                        {/* If no restaurant is selected, the guide page will be displayed.
                         Otherwise the appropriate restaurant card is shown */}
                        {selectedRestaurantId !== -1 
                        ?
                        <RestaurantCard
                            restaurant={restaurants.find(
                                (restaurant) => restaurant.restaurantID === selectedRestaurantId
                            )}
                        />
                        :
                        <GuidePage/>
                        }
                </div>

                <Footer/>
            </div>
        </div>
        </ThemeContext.Provider>
    );
};

export default App;
